import { useEffect, useState } from "react";

export default function SMTPSettings() {
  const BASE_URL = import.meta.env.VITE_LYRAZONE_BASE_URL;

  const [form, setForm] = useState({
    host: "",
    port: "",
    username: "",
    password: "",
    from_email: "",
    encryption: "tls",
  });

  /* =========================
     FETCH SMTP
  ========================= */

  const fetchSMTP = async () => {
    const res = await fetch(`${BASE_URL}/admin/settings/smtp`, {
      credentials: "include",
    });

    const result = await res.json();

    if (result.success) {
      setForm(result.data);
    }
  };

  useEffect(() => {
    fetchSMTP();
  }, []);

  /* =========================
     HANDLE CHANGE
  ========================= */

  const handleChange = (key: string, value: any) => {
    setForm((prev) => ({
      ...prev,
      [key]: value,
    }));
  };

  /* =========================
     SAVE
  ========================= */

  const handleSave = async () => {
    const res = await fetch(`${BASE_URL}/admin/settings/smtp`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      credentials: "include",
      body: JSON.stringify(form),
    });

    const result = await res.json();

    if (result.success) {
      alert("SMTP settings saved successfully");
    }
  };

  return (
    <div className="smtp-settings">
      <h2>SMTP Settings</h2>

      <div className="smtp-form">
        <div className="form-group">
          <label>SMTP Host</label>
          <input
            value={form.host}
            onChange={(e) => handleChange("host", e.target.value)}
          />
        </div>

        <div className="form-group">
          <label>SMTP Port</label>
          <input
            value={form.port}
            onChange={(e) => handleChange("port", e.target.value)}
          />
        </div>

        <div className="form-group">
          <label>Username</label>
          <input
            value={form.username}
            onChange={(e) => handleChange("username", e.target.value)}
          />
        </div>

        <div className="form-group">
          <label>Password</label>
          <input
            type="password"
            value={form.password}
            onChange={(e) => handleChange("password", e.target.value)}
          />
        </div>

        <div className="form-group">
          <label>From Email</label>
          <input
            value={form.from_email}
            onChange={(e) => handleChange("from_email", e.target.value)}
          />
        </div>

        <div className="form-group">
          <label>Encryption</label>

          <select
            value={form.encryption}
            onChange={(e) => handleChange("encryption", e.target.value)}
          >
            <option value="tls">TLS</option>
            <option value="ssl">SSL</option>
          </select>
        </div>

        <button className="btn-primary" onClick={handleSave}>
          Save SMTP Settings
        </button>
      </div>
    </div>
  );
}
